export enum Shifts {
  DAY = 100,
  MID = 200,
  NIGHT = 300,
  FE_HOURS = 400,
  FT_HOURS = 500,
  TT_HOURS = 600,
}
